import { OtpChannel } from 'src/app/core/models/custom-types.model';

export const environment = {
  production: false,
  LABEL: 'SVILUPPO',
  TOKEN_KEY: 'my-token',
  TOKEN_KEY_ID: 'my-token-id',
  USER_KEY: 'utente',
  USER_PROFILE_KEY: 'profilo_',
  USER_EMAIL: 'my-email',
  SALDO_PUNTI: 'saldo_punti_premio',
  INTRO_KEY: 'intro-seen',
  SIGN_VAL: 'verifica-pre-reg',
  DEVICE_ID: 'uuid',
  API_ENDPOINT: 'https://api.pnit.it/api',
  CSRF_ENDPOINT: 'https://api.pnit.it/',
  LOGO_HEADER: 'logo_primonetwork_app_SVILUPPO.webp',
  LINK_REGISTRAZIONE: 'https://app.pnit.it/signup/',
  LINK_REGOLAMENTO:
    'https://api.pnit.it/storage/Catalogo_Premi_e_Regolamento_2021-2026.pdf',
  LINK_SITO: 'https://app.pnit.it',
  ELENCO_PREMI: 'my-rewards',
  QR_CODE: '',
  DEFAULT_OTP: 'email' as OtpChannel,
  AUTH_APP_URL: 'https://auth.pnit.it',
  TARGET_APP: 'manifestazione',
  SSO_EXCHANGE_TICKET_ENDPOINT: 'sso/exchange-ticket',
  SSO_REDIRECT_MAX_ATTEMPTS: 3,
  SSO_DEFAULT_LANDING: '/app/utente',
  ENABLE_ALERTS: false,
  ENABLE_CONSOLE_LOGS: true,
};
